export const TagType = {
    ORGANIZATION_TAG: 0,
    USER_TAG: 1
  };
  